import PropTypes from 'prop-types';
import * as React from 'react';
import './LoadingStyle.scss';
import { Row, Container } from 'reactstrap';

function Loading({
  cover,
  show,
}) {
  if (!show) return null;
  return (
    <div className={`${cover ? 'full-screen' : 'loading'}`}>
      <Container>
        <Row className="align-items-center justify-content-center">
          <div className="spinner-border text-primary" role="status" />
        </Row>
      </Container>
    </div>
  );
}

Loading.propTypes = {
  cover: PropTypes.bool.isRequired,
  show: PropTypes.bool.isRequired,
};

export default Loading;
